import React from 'react';

interface FolderIconProps {
  style?: object;
  /** Rendered width/height in px. */
  size?: number;
}

export const FolderIcon: React.FC<FolderIconProps> = ({ style, size = 20 }) => {
  return (
    <svg
      role="presentation"
      focusable="false"
      viewBox="0 0 20 20"
      width={size}
      height={size}
      style={style}
    >
      <defs>
        <linearGradient
          id="FilesZipIconLinearGradient"
          x1="1"
          y1="5"
          x2="1"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.01"></stop>
          <stop offset="0.999" stopColor="#FFD75E" stopOpacity="0.3"></stop>
        </linearGradient>
      </defs>
      <path
        d="M10 5L8.586 3.586C8.21101 3.2109 7.70239 3.00011 7.172 3H2C1.44772 3 1 3.44772 1 4V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H10Z"
        fill="#FFB900"
      ></path>
      <path
        d="M10 5L8.586 6.414C8.21101 6.7891 7.70239 6.99989 7.172 7H1V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H10Z"
        fill="#FFD75E"
      ></path>
      <path
        d="M10 5L8.586 6.414C8.21101 6.7891 7.70239 6.99989 7.172 7H1V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H10Z"
        fill="url(#FilesZipIconLinearGradient)"
      ></path>
      <path
        d="M1.99986 16.4999C1.62686 16.4999 1.28986 16.3579 1.02686 16.1329C1.08759 16.6252 1.50388 16.9961 1.99986 16.9999H17.9999C18.5049 16.9999 18.9049 16.6199 18.9729 16.1329C18.7109 16.3589 18.3729 16.4999 17.9999 16.4999H1.99986Z"
        fill="#E67628"
      ></path>
      <path
        opacity="0.4"
        d="M8.836 6.914L10.75 5H10L8.586 6.414C8.21101 6.7891 7.70239 6.99989 7.172 7H1V7.5H7.422C7.95239 7.49989 8.46101 7.2891 8.836 6.914Z"
        fill="white"
      ></path>
    </svg>
  );
};
